export default {"src":"/login-app/[GIT_HASH]/_next/static/media/successful_trend.eb9b8a4b.svg","height":16,"width":16,"blurWidth":0,"blurHeight":0};